import Pristine from 'pristinejs'
import jump from 'jump.js'

const props = {
    $checkoutForm: document.querySelector('.checkout-form'),
    $billingSameOption: document.querySelector('#checkout-same-as-shipping'),
    $billingDifferentOption: document.querySelector('#checkout-different-billing'),
    $shippingFieldset: document.querySelector('.store-checkout-shipping'),
    $shippingStreet: document.querySelector('input[name=ShippingAddress1]'),
    $shippingCity: document.querySelector('input[name=ShippingCity'),
    $shippingState: document.querySelector('select[name=ShippingState]'),
    $shippingZip: document.querySelector('input[name=ShippingZip]'),
    $billingFieldset: document.querySelector('.store-checkout-billing'),
    $billingState: document.querySelector('select[name=BillingState]'),
    $orderTotal: document.querySelector('input[name=OrderTotal]'),
    $orderTotalLabel: document.querySelector('.order-total-all'),
    $subTotal: document.querySelector('input[name=OrderSubTotal]'),
    $subTotalLabel: document.querySelector('.order-subtotal'),
    $shippingTotal: document.querySelector('input[name=ShippingTotal]'),
    $shippingTotalLabel: document.querySelector('.shipping-total'),
    $quantity: document.querySelector('input[name=Quantity]'),
    $taxTotal: document.querySelector('input[name=Tax]'),
    $taxTotalLabel: document.querySelector('.order-tax'),
    $cardElement: document.querySelector('.StripeElement'),
    $orderSummaryToggle: document.querySelector('.order-summary-toggle'),
    $orderSummary: document.querySelector('.order-summary'),
    stripe: null,
    stripeCard: null,
    pristine: null,
    pristineConfig: {
      classTo: 'field',
      errorClass: 'has-error',
      successClass: 'has-success',
      errorTextParent: 'field',
      errorTextTag: 'div',
      errorTextClass: 'text-help',
    },
}

const billingRequireds = [
    'BillingFirstName',
    'BillingLastName',
    'BillingEmail',
    'BillingPhoneNumber',
    'BillingCompany',
    'BillingAddress1',
    'BillingCity',
    'BillingZip',
    'BillingState'
]

const setupCheckout = () => {
    if (!$('body').hasClass('pagetype-checkoutpage')) {
        return
    }
    if (!document.querySelector('.checkout-form')) {
        return
    }
    props.pristine = new Pristine(props.$checkoutForm, props.pristineConfig)

    props.stripe = window.Stripe(props.$checkoutForm.dataset.stripePubKey)
    setupStripeCard()

    props.$shippingState.addEventListener("change", function(e) {
        handleStateChange()
    })

    props.$billingSameOption.addEventListener("change", function(e) {
        handleSameAsShipping()
    })

    props.$billingDifferentOption.addEventListener("change", function(e) {
        handleDifferentAsShipping()
    })

    props.$shippingZip.addEventListener("change", (e) => {
        if (e.target.value.length >= 5) {
            handleShippingCalculation()
        }
    })

    props.$checkoutForm.addEventListener('submit', (event) => {
        handleCheckout(event)
    })

    props.$orderSummaryToggle.addEventListener('click', (event) => {
        event.preventDefault()
        handleSummaryToggle()
    })

}

function handleSameAsShipping() {
    props.$billingFieldset.style.display = 'none'

    let isState = false;
    billingRequireds.forEach(function(value) {
        let f = 'input[name=' + value + ']'
        if (value == 'BillingState') {
            f = 'select[name=' + value + ']'
            isState = true
        }
        let field = props.$checkoutForm.querySelector(f)
        field.removeAttribute('required')
        if (isState) {
        }
        else {
            let label = field.getAttribute('data-label')
            field.previousElementSibling.innerHTML = label
        }
        field.focus()
        field.blur()

    })

    props.pristine = new Pristine(props.$checkoutForm, props.pristineConfig)

}

function handleDifferentAsShipping() {
    props.$billingFieldset.style.display = 'block'

    let isState = false;
    billingRequireds.forEach(function(value) {
        let f = 'input[name=' + value + ']'
        if (value == 'BillingState') {
            f = 'select[name=' + value + ']'
            isState = true
        }
        let field = props.$checkoutForm.querySelector(f)
        field.setAttribute('required', 'required')
        let label = field.getAttribute('data-label')
        if (isState) {
            field.value = ''
        }
        else {
            field.previousElementSibling.innerHTML = label + '*'
        }
        field.focus()
        field.blur()
    })

    props.pristine = new Pristine(props.$checkoutForm, props.pristineConfig)

}

function handleStateChange() {

    const state = props.$shippingState.value
    props.$billingState.value = state

}

function handleShippingCalculation() {
    let zip = props.$shippingZip.value
    let quantity = props.$quantity.value
    let type = props.$checkoutForm.dataset.specType
    let maxQuantity = props.$checkoutForm.dataset.maxQuantity

    if (zip != '') {
        if (quantity > maxQuantity || type == 'Shelter') {
            handleTaxes()
        }
        else {
            const url = props.$checkoutForm.dataset.pageLink + 'calculateshipping/' + zip

            fetch(url).then((response) => response.json()).then(function (json) {
                if (json.cost) {
                    updateShipping(json.cost)
                }
                else if (json.error) {
                    let error = json.error
                    props.$shippingZip.nextElementSibling.innerHTML = error
                    props.$shippingZip.nextElementSibling.style.display = 'block'
                }
            }).then(function() {
                handleTaxes()
            });
        }
    }
}

function updateShipping(shippingCost) {

    props.$shippingTotal.value = shippingCost
    let newTotal = parseFloat(props.$subTotal.value) + parseFloat(shippingCost)
    props.$orderTotal.value = newTotal

    let formatCurrency = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
    })

    props.$shippingTotalLabel.innerHTML = formatCurrency.format(shippingCost)
    props.$orderTotalLabel.innerHTML = formatCurrency.format(newTotal)

}

function handleTaxes() {

    let street = props.$shippingStreet.value
    let city = props.$shippingCity.value
    let state = props.$shippingState.value
    let zip = props.$shippingZip.value
    let amount = props.$subTotal.value
    let shipping = props.$shippingTotal.value

    let quantity = props.$quantity.value
    let maxQuantity = props.$checkoutForm.dataset.maxQuantity

    if (amount == '') { return false }
    if (props.$checkoutForm.dataset.specType == 'Building') {
        if (shipping == '' && quantity < maxQuantity) {
            return false
        }
    }

    if (state == '' && zip != '') {

        let stateurl = props.$checkoutForm.dataset.pageLink + 'findstate/' + zip
        fetch(stateurl).then((response) => response.json()).then(function (json) {
            if (json.success) {
                state = json.state
                let url = props.$checkoutForm.dataset.pageLink + 'calculatetax/'
                url += '?street=' + street + '&city=' + city + '&state=' + json.state + '&zip=' + zip + '&amount=' + amount + '&shipping=' + shipping

                fetch(url).then((response) => response.json()).then(function (json) {
                    if (json.success) {
                        updateTaxes(json.tax)
                    }
                    else {
                        let error = json.error
                        props.$shippingZip.nextElementSibling.innerHTML = error
                        props.$shippingZip.nextElementSibling.style.display = 'block'
                    }
                });

            }
            else {
                let error = json.error
                props.$shippingZip.nextElementSibling.innerHTML = error
                props.$shippingZip.nextElementSibling.style.display = 'block'
            }
        })
    }
    else {

        let url = props.$checkoutForm.dataset.pageLink + 'calculatetax/'
        url += '?street=' + street + '&city=' + city + '&state=' + state + '&zip=' + zip + '&amount=' + amount + '&shipping=' + shipping

        fetch(url).then((response) => response.json()).then(function (json) {
            if (json.success) {
                updateTaxes(json.tax)
            }
            else {
                let error = json.error
                props.$shippingZip.nextElementSibling.innerHTML = error
                props.$shippingZip.nextElementSibling.style.display = 'block'
            }
        });

    }

}

function updateTaxes(taxCost) {

    props.$taxTotal.value = taxCost

    let shippingTotal = parseFloat(0)
    if (props.$shippingTotal.value != '') {
        shippingTotal = parseFloat(props.$shippingTotal.value)
    }

    let newTotal = parseFloat(props.$subTotal.value) + shippingTotal + parseFloat(taxCost)
    props.$orderTotal.value = newTotal

    let formatCurrency = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
    })

    props.$taxTotalLabel.innerHTML = formatCurrency.format(taxCost)
    props.$orderTotalLabel.innerHTML = formatCurrency.format(newTotal)

}

function setupStripeCard() {
    let fontSize = '16px'

    if (window.matchMedia('(min-width: 1200px)').matches) {
        fontSize = '17px'
    }

    if (window.matchMedia('(min-width: 1440px)').matches) {
        fontSize = '19px'
    }

    const style = {
        base: {
            fontSize: fontSize,
            fontFamily: 'Source Sans Pro, sans-serif',
            color: '#2c2c2c',
            fontSmoothing: 'antialiased',

            '::placeholder': {
              color: '#d6d6d6',
            },
        },
        invalid: {
            color: '#b9112a',
        },
    }

    const card = props.stripe.elements().create('card', { style })
    card.mount('#card-element')
    props.stripeCard = card

    card.addEventListener('change', ({ error }) => {
        const displayError = document.getElementById('card-errors')
        if (error) {
            displayError.textContent = error.message
        } else {
            displayError.textContent = ''
        }
    })
}

function handleCheckout(e) {

    e.preventDefault()

    let valid = props.pristine.validate()
    props.$checkoutForm.classList.add('is-validating')

    if (!valid) {
        const $firstError = props.$checkoutForm.querySelector('.field.has-error')

        if ($firstError) {
            scrollTo($firstError, 150, () => $firstError.querySelector('input').focus())
        }
    }
    else {

        let $stripeElement = document.querySelector('.StripeElement')
        if ($stripeElement.classList.contains('StripeElement--complete')) {
            if (document.querySelector('.order-total-all').innerHTML != '0.00') {
                props.stripe.createToken(props.stripeCard).then(result => {
                    if (result.error) {
                        const errorElement = document.getElementById('card-errors')
                        errorElement.textContent = result.error.message
                        const $submitButton = props.$checkoutForm.querySelector('[type=submit]')
                        $submitButton.disabled = false
                    }
                    else {
                        stripeTokenHandler(result.token)
                    }
                })
            }
        }
        else {

            const $firstError = $stripeElement

            if ($firstError) {
                const displayError = document.getElementById('card-errors')
                displayError.textContent = 'Please enter your credit card information'

                scrollTo($firstError, 150, () => $firstError.querySelector('input').focus())
            }

        }

    }

    return false
}

function handleSummaryToggle() {

    if (props.$orderSummary.classList.contains('open')) {
        props.$orderSummary.classList.remove('open')
        props.$orderSummaryToggle.querySelector('svg').classList.remove('open')
    }
    else {
        props.$orderSummary.classList.add('open')
        props.$orderSummaryToggle.querySelector('svg').classList.add('open')
    }

}


function stripeTokenHandler(token) {
    const $form = props.$checkoutForm

    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeToken')
    hiddenInput.setAttribute('value', token.id)
    $form.appendChild(hiddenInput)

    $form.submit()
}

function scrollTo($target, additionalOffset = 0, callback) {
    const $header = document.querySelector('.site-header')
    const headerOffset = $header.offsetHeight * -1
    const offset = headerOffset - additionalOffset

    jump($target, { duration: 500, offset, callback })
}

setupCheckout()
